import * as Dtos from "../dtos/Tmd.dtos";
import { IFormFilter } from "../reducers/index";

export const
    LoadGroupItemCategoriesByGroupId: IGroupItemCategoriesLoadByGroupIdActionCreator = (groupId) => {
        return {
            type: ACTION_GROUPITEMCATEGORIES_LOAD_BY_GROUPID,
            groupId
        }
    },
    LoadSuccess: IGroupItemCategoriesLoadByGroupIdSuccessActionCreator = (formData, formProperties, lookups, responseStatus) => {
        return {
            type: ACTION_GROUPITEMCATEGORIES_LOAD_BY_GROUPID_SUCCESS,
            formData,
            formProperties,
            lookups,
            responseStatus
        }
    },
    LoadFailure: IGroupItemCategoriesLoadByGroupIdFailureActionCreator = (responseStatus) => {
        return {
            type: ACTION_GROUPITEMCATEGORIES_LOAD_BY_GROUPID_FAILURE,
            responseStatus
        }
    },

    Clear: IGroupItemCategoriesClearActionCreator = (propertiesToClear?) => {
        return {
            type: ACTION_GROUPITEMCATEGORIES_CLEAR,
            propertiesToClear
        }
    },

    Filter: IGroupItemCategoriesFilterActionCreator = (formFilter) => {
        return {
            type: ACTION_GROUPITEMCATEGORIES_FILTER,
            formFilter
        }
    };


export const
    ACTION_GROUPITEMCATEGORIES_LOAD_BY_GROUPID = "ACTION_GROUPITEMCATEGORIES_LOAD_BY_GROUPID",
    ACTION_GROUPITEMCATEGORIES_LOAD_BY_GROUPID_SUCCESS = "ACTION_GROUPITEMCATEGORIES_LOAD_BY_GROUPID_SUCCESS",
    ACTION_GROUPITEMCATEGORIES_LOAD_BY_GROUPID_FAILURE = "ACTION_GROUPITEMCATEGORIES_LOAD_BY_GROUPID_FAILURE",

    ACTION_GROUPITEMCATEGORIES_CLEAR = "ACTION_GROUPITEMCATEGORIES_CLEAR",

    ACTION_GROUPITEMCATEGORIES_FILTER = "ACTION_GROUPITEMCATEGORIES_FILTER";

export interface IGroupItemCategoriesLoadByGroupIdAction {
    type: "ACTION_GROUPITEMCATEGORIES_LOAD_BY_GROUPID";
    groupId?: number;
}

export interface IGroupItemCategoriesLoadByGroupIdActionCreator {
    (groupId?: number): IGroupItemCategoriesLoadByGroupIdAction;
}

export interface IGroupItemCategoriesLoadByGroupIdSuccessAction {
    type: "ACTION_GROUPITEMCATEGORIES_LOAD_BY_GROUPID_SUCCESS";
    formData: Dtos.GroupItemCategory[];
    formProperties: Dtos.FormProperty[];
    lookups: Dtos.Lookup[];
    responseStatus: Dtos.ResponseStatus;
}

export interface IGroupItemCategoriesLoadByGroupIdSuccessActionCreator {
    (
        formData: Dtos.GroupItemCategory[],
        formProperties: Dtos.FormProperty[],
        lookups: Dtos.Lookup[],
        responseStatus: Dtos.ResponseStatus
    ): IGroupItemCategoriesLoadByGroupIdSuccessAction;
}

export interface IGroupItemCategoriesLoadByGroupIdFailureAction {
    type: "ACTION_GROUPITEMCATEGORIES_LOAD_BY_GROUPID_FAILURE";
    responseStatus: Dtos.ResponseStatus;
}

export interface IGroupItemCategoriesLoadByGroupIdFailureActionCreator {
    (responseStatus: Dtos.ResponseStatus): IGroupItemCategoriesLoadByGroupIdFailureAction;
}

export interface IGroupItemCategoriesClearAction {
    type: "ACTION_GROUPITEMCATEGORIES_CLEAR";
    propertiesToClear?: string[];
}

export interface IGroupItemCategoriesClearActionCreator {
    (propertiesToClear?: string[]): IGroupItemCategoriesClearAction;
}

export interface IGroupItemCategoriesFilterActionCreator {
    (formFilter: IFormFilter): IGroupItemCategoriesFilterAction;
}

export interface IGroupItemCategoriesFilterAction {
    type: "ACTION_GROUPITEMCATEGORIES_FILTER";
    formFilter: IFormFilter;
}

export type GroupItemCategoryActions =
    IGroupItemCategoriesLoadByGroupIdAction |
    IGroupItemCategoriesLoadByGroupIdSuccessAction |
    IGroupItemCategoriesLoadByGroupIdFailureAction |
    IGroupItemCategoriesClearAction |
    IGroupItemCategoriesFilterAction;